__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/2d9d60b6f929e0ca317191dca04b7cdec5126eac/_next/";